import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import MoreActionsPopover from '../../dataSources/components/MoreActionsPopover';
import css from './MonitorMenu.css';

const MonitorMenu = ({ actions }) => {
    const [anchor, setAnchor] = useState(null);

    return (
        <div className={css.menuWrapper} data-testid="monitor-menu" onClick={e => e.stopPropagation()}>
            <Icon
                name="dots-vertical"
                size={IconSizes.SMALL}
                onClick={e => {
                    const trigger = e.currentTarget;
                    setAnchor(current => (current ? null : trigger));
                }}
            />
            {anchor && (
                <MoreActionsPopover
                    showExtendedMenu
                    onCloseExtendedMenu={() => setAnchor(null)}
                    anchorEl={anchor}
                    actionComponentsConfigs={actions}
                />
            )}
        </div>
    );
};

MonitorMenu.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            title: PropTypes.string,
            onClick: PropTypes.func,
        })
    ).isRequired,
};

export default MonitorMenu;
